import Vue from "vue";

// base library
import Antd from "ant-design-vue";
import Viser from "viser-vue";
import "ant-design-vue/dist/antd.less";
import VueCropper from "vue-cropper";

// ext library
import VueClipboard from "vue-clipboard2";
import MultiTab from "@/components/MultiTab";
import PageLoading from "@/components/PageLoading";
import Authorized from "@/components/Authorized";
import UnAuthorized from "@/components/UnAuthorized";

VueClipboard.config.autoSetContainer = true;

Vue.use(Antd);
Vue.use(Viser);
Vue.use(MultiTab);
Vue.use(PageLoading);
Vue.use(VueClipboard);
Vue.use(VueCropper);
Vue.component("Authorized", Authorized);
Vue.component("UnAuthorized", UnAuthorized);

process.env.NODE_ENV !== "production" &&
  console.warn("[antd-pro] WARNING: Antd now use fulled imported.");
